import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { BUSINESS, NAV_LINKS, LOGO_URL, BANKS } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="bg-[#0B1220] text-white mt-16">
      <div className="road-stripe" aria-hidden />

      {/* Banks strip */}
      <div className="bg-white/5 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-xs uppercase tracking-widest text-[#F59E0B] font-semibold text-center mb-3">Supported Banks & Partners</div>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/80">
            {BANKS.map(b => <span key={b} className="whitespace-nowrap">{b}</span>)}
            <span className="whitespace-nowrap text-[#F59E0B]">& many more issuers</span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="Logo" className="w-12 h-12 rounded-full object-contain bg-white/5 ring-1 ring-white/10" />
            <div>
              <div className="font-display font-bold">FASTag CSP</div>
              <div className="text-xs tracking-widest uppercase text-[#F59E0B]">Sayeed Anwar · Bally</div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            {BUSINESS.tagline}. Instant issuance, blacklist / hotlist removal, KYC support and delivery across all 23 districts of West Bengal.
          </p>
        </div>

        <div>
          <div className="text-sm font-semibold uppercase tracking-wider text-[#F59E0B] mb-4">Explore</div>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-white/80 hover:text-white transition-colors duration-200">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/find-us" className="text-sm text-white/80 hover:text-white">Find Us</Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold uppercase tracking-wider text-[#F59E0B] mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#F59E0B] shrink-0" /> {BUSINESS.address}</li>
            <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#F59E0B] shrink-0" /> <a href={`tel:${BUSINESS.phone}`} className="hover:text-white">{BUSINESS.phoneDisplay}</a></li>
            <li className="flex gap-2"><MessageCircle className="w-4 h-4 mt-0.5 text-[#F59E0B] shrink-0" /> <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noreferrer" className="hover:text-white">WhatsApp Chat</a></li>
            <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#F59E0B] shrink-0" /> <a href={`mailto:${BUSINESS.email}`} className="hover:text-white">{BUSINESS.email}</a></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold uppercase tracking-wider text-[#F59E0B] mb-4">Opening Hours</div>
          <ul className="space-y-2 text-sm text-white/80">
            {BUSINESS.hours.map((h) => (
              <li key={h.day} className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-[#F59E0B]" />
                <span className="font-medium">{h.day}</span>
                <span className="text-white/60 ml-auto">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Fastag CSP Bally Toll. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
            <span>Website: Editable template — details verify with owner.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
